const style = {
  root: {
    padding: '2rem',
    '&:last-child': {
      paddingBottom: 0
    }
  }
}

export default style